<lms-dynamic-form [questions]="questions" [title]="'credits.pageLabels.add'" (submit)="submit($event)">
  <ng-content select="[form-actions-before]" form-actions-before></ng-content>
</lms-dynamic-form>
